import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/access/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/integrations/access/mcp' });
  },
});
